// Causas cuyo protocolo asignado por el backend es "delitos" pero que, a
// pedido del negocio, deben mostrarse en los informes (PDF y su vista previa)
// como "Riesgos de Procesos". Es un cambio puramente visual: el protocolo
// real que maneja la API sigue siendo "delitos".
const CAUSAS_RIESGO_DE_PROCESO = ["hurto-destreza", "hurto-descuido", "hurto-fuerza"];

/**
 * @param {string} protocolValue - `protocol` del bloque de protocolo (p. ej. "delitos").
 * @param {Array} causes - `causes` del evento, cada uno con `protocol_cause`.
 */
export function getProtocolDisplayLabel(protocolValue, causes = []) {
  const esRiesgoDeProceso =
    protocolValue === "delitos" &&
    causes.some((causa) =>
      CAUSAS_RIESGO_DE_PROCESO.some((clave) => causa?.protocol_cause?.includes(clave)),
    );

  return esRiesgoDeProceso ? "Riesgos de Procesos" : protocolValue;
}
